var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlower2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 505 486",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.974 137.446C356.246 149.075 327.827 168.253 305.171 193.324C322.015 163.972 331.382 130.928 332.448 97.1034C332.448 26.4828 253 0 253 0C253 0 173.552 26.4828 173.552 97.1034C174.618 130.928 183.985 163.972 200.829 193.324C178.133 168.382 149.717 149.326 118.026 137.799C50.8482 115.641 1.14893 182.996 1.14893 182.996C1.14893 182.996 1.76685 266.77 68.9448 288.927C101.421 298.306 135.702 299.579 168.785 292.634C137.889 306.459 110.875 327.682 90.131 354.428C48.6413 411.542 97.3696 479.691 97.3696 479.691C97.3696 479.691 176.818 504.938 218.661 447.823C237.8 419.561 249.601 386.978 253 353.015C256.499 386.765 268.296 419.123 287.339 447.206C328.829 504.32 408.63 479.073 408.63 479.073C408.63 479.073 457.359 410.924 415.869 353.81C395.171 327.126 368.259 305.912 337.48 292.017C370.474 298.965 404.67 297.691 437.055 288.309C504.233 266.505 504.851 182.378 504.851 182.378C504.851 182.378 455.152 115.641 387.974 137.446Z",
    fill: "#F0C419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.448 97.1034C332.448 152.452 300.316 210.097 264.829 251.763C259.151 246.625 250.808 245.734 244.172 249.556C231.689 229.377 217.165 210.534 200.829 193.324C202.33 193.324 173.552 150.863 173.552 97.1034C173.552 26.4828 253 0 253 0C253 0 332.448 26.4828 332.448 97.1034Z",
    fill: "#CC6A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M332.448 97.1034C332.448 152.452 300.316 210.097 264.829 251.763C259.151 246.625 250.808 245.734 244.172 249.556C231.689 229.377 217.165 210.534 200.829 193.324C202.33 193.324 173.552 150.863 173.552 97.1034C173.552 26.4828 253 0 253 0C253 0 332.448 26.4828 332.448 97.1034Z",
    fill: "url(#paint0_linear_1692_139449)",
    fillOpacity: 0.48
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253 256C248.125 256 244.172 252.048 244.172 247.172V141.241C244.172 136.366 248.125 132.414 253 132.414C257.875 132.414 261.828 136.366 261.828 141.241V247.172C261.828 252.048 257.875 256 253 256Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.345 268.535C212.332 274.062 189.964 281.991 168.608 292.193C135.467 299.089 101.148 297.847 68.5918 288.574C1.41383 266.77 0.795898 182.643 0.795898 182.643C0.795898 182.643 50.8483 115.641 118.026 137.446C170.992 154.571 215.13 202.593 244.172 249.556C237.393 253.268 233.816 260.958 235.345 268.535Z",
    fill: "#FF9019"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.345 268.535C212.332 274.062 189.964 281.991 168.608 292.193C135.467 299.089 101.148 297.847 68.5918 288.574C1.41383 266.77 0.795898 182.643 0.795898 182.643C0.795898 182.643 50.8483 115.641 118.026 137.446C170.992 154.571 215.13 202.593 244.172 249.556C237.393 253.268 233.816 260.958 235.345 268.535Z",
    fill: "url(#paint1_linear_1692_139449)",
    fillOpacity: 0.48
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.228 268.182C234.197 268.182 241.877 270.566 132.768 234.99C128.314 233.35 125.954 228.481 127.427 223.968C128.899 219.455 133.677 216.915 138.241 218.218L238.964 250.968C243.08 252.321 245.606 256.461 244.926 260.74C244.246 265.02 240.56 268.172 236.228 268.182Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253 353.015C249.501 386.765 237.704 419.123 218.661 447.205C177.171 504.32 97.3698 479.073 97.3698 479.073C97.3698 479.073 48.6415 410.924 90.1311 353.81C122.44 309.319 182.379 281.6 235.345 268.535C236.949 276.013 243.185 281.608 250.793 282.394C249.087 305.948 249.827 329.614 253 353.015Z",
    fill: "#F07C00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253 353.015C249.501 386.765 237.704 419.123 218.661 447.205C177.171 504.32 97.3698 479.073 97.3698 479.073C97.3698 479.073 48.6415 410.924 90.1311 353.81C122.44 309.319 182.379 281.6 235.345 268.535C236.949 276.013 243.185 281.608 250.793 282.394C249.087 305.948 249.827 329.614 253 353.015Z",
    fill: "url(#paint2_linear_1692_139449)",
    fillOpacity: 0.48
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.349 373.672C177.085 373.551 174.154 371.638 172.73 368.698C171.306 365.758 171.622 362.272 173.552 359.636L235.345 273.92C237.332 271.46 240.48 270.247 243.604 270.738C246.728 271.228 249.353 273.348 250.489 276.299C251.626 279.25 251.103 282.583 249.116 285.043L187.323 370.052C185.693 372.284 183.112 373.623 180.349 373.672Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M408.63 479.073C408.63 479.073 329.182 504.32 287.339 447.205C254.677 402.273 246.997 336.949 251.146 282.394C258.651 283.044 265.741 278.861 268.801 271.978C290.744 281.027 313.548 287.83 336.862 292.281C367.72 306.168 394.72 327.38 415.516 354.074C457.359 410.924 408.63 479.073 408.63 479.073Z",
    fill: "#FF9019"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M408.63 479.073C408.63 479.073 329.182 504.32 287.339 447.205C254.677 402.273 246.997 336.949 251.146 282.394C258.651 283.044 265.741 278.861 268.801 271.978C290.744 281.027 313.548 287.83 336.862 292.281C367.72 306.168 394.72 327.38 415.516 354.074C457.359 410.924 408.63 479.073 408.63 479.073Z",
    fill: "url(#paint3_linear_1692_139449)",
    fillOpacity: 0.48
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M325.651 373.672C322.826 373.679 320.168 372.334 318.501 370.052L256.178 284.337C254.317 281.75 253.977 278.368 255.287 275.464C256.596 272.559 259.355 270.574 262.525 270.255C265.695 269.937 268.794 271.334 270.655 273.92L332.448 359.636C334.378 362.272 334.694 365.758 333.27 368.698C331.846 371.638 328.915 373.551 325.651 373.672Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M504.851 182.996C504.851 182.996 504.233 266.77 437.055 288.927C384.09 306.582 320.178 293.429 269.331 272.331C272.398 265.365 270.654 257.217 265.006 252.116C280.379 233.951 293.839 214.25 305.171 193.324C327.867 168.382 356.283 149.327 387.974 137.799C455.152 115.641 504.851 182.996 504.851 182.996Z",
    fill: "#F07C00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M504.851 182.996C504.851 182.996 504.233 266.77 437.055 288.927C384.09 306.582 320.178 293.429 269.331 272.331C272.398 265.365 270.654 257.217 265.006 252.116C280.379 233.951 293.839 214.25 305.171 193.324C327.867 168.382 356.283 149.327 387.974 137.799C455.152 115.641 504.851 182.996 504.851 182.996Z",
    fill: "url(#paint4_linear_1692_139449)",
    fillOpacity: 0.48
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M269.772 268.182C265.44 268.172 261.754 265.02 261.074 260.74C260.394 256.461 262.92 252.321 267.036 250.968L367.759 218.218C372.323 216.915 377.101 219.455 378.573 223.968C380.046 228.481 377.686 233.35 373.232 234.99C264.034 270.566 271.891 268.182 269.772 268.182Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280 264.971C280.013 278.077 270.613 289.299 257.708 291.584C244.803 293.869 232.121 286.555 227.635 274.242C223.148 261.928 228.153 248.17 239.503 241.617C247.852 236.797 258.137 236.794 266.489 241.61C274.84 246.426 279.99 255.33 280 264.971Z",
    fill: "#FFA23F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1692_139449",
    x1: 299.714,
    y1: -0.286049,
    x2: 221.917,
    y2: 241.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1692_139449",
    x1: 244,
    y1: 215.29,
    x2: 19.128,
    y2: 279.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1692_139449",
    x1: 216,
    y1: 268.29,
    x2: 163.199,
    y2: 484.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1692_139449",
    x1: 394.912,
    y1: 271.736,
    x2: 344.382,
    y2: 485.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1692_139449",
    x1: 504.681,
    y1: 215.702,
    x2: 282.528,
    y2: 277.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower2);
export default __webpack_public_path__ + "static/media/flower2.9df5b196df1bd585be5ce0f19c89b869.svg";
export { ForwardRef as ReactComponent };